import React, { useEffect, useState } from "react";
import { BlogService } from "../../../helper/services/blog-service";
import ShBlogCard from "../../../page-components/blog-card/shBlogCard";

const BlogCard = ( { blogId } ) => {

    const [ blog, setBlog ] = useState(null);

    useEffect(
        () => {
            const action = async () => {
                const blogService = new BlogService();
                const blogs = await blogService.fetchList()

                const blog = blogs.find( b => b.id === blogId);
                setBlog(blog);

            };
            action();
        },
        []
    );


    if (!blog) {
        return null;
    }

    return <ShBlogCard blog={blog} shortVersion={true} className={"h-100"}/>

};

export default BlogCard;
